
    import "src/app/AppAdmin/D2R/CreditNote/index.module.scss?farm_css_modules";
    
    export default {"creditNoteStatusFilter": `creditNoteStatusFilter-f47fbc7b`,"topHeader": `topHeader-f47fbc7b`}
    